import { render, staticRenderFns } from "./DocumentosPreaspirante.vue?vue&type=template&id=c64d5228&scoped=true"
import script from "./DocumentosPreaspirante.vue?vue&type=script&lang=js"
export * from "./DocumentosPreaspirante.vue?vue&type=script&lang=js"
import style0 from "./DocumentosPreaspirante.vue?vue&type=style&index=0&id=c64d5228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c64d5228",
  null
  
)

export default component.exports